module.exports = __webpack_public_path__ + "img/eth-blocks-qrs.46f7c509.svg";